import React from 'react';
import './index.css';
import { Tabs,WingBlank } from 'antd-mobile';
import { StickyContainer, Sticky } from 'react-sticky';
import TabCatalog from '../tabCatalog'
import TabInterlocution from '../tabInterlocution'
import {
  connect
} from 'react-redux';
import {
  actionCreators
} from 'labroomVideoStore';
function renderTabBar(props) {
  return (<Sticky>
    {({ style }) => <div style={{ ...style, zIndex: 20,top:'45px' }}><Tabs.DefaultTabBar {...props} /></div>}
  </Sticky>);
}
const tabs = [
  { title: '目录' },
  { title: '问答' },
];
class VideoTab extends React.Component{
  videoClick(id,sid){
    const {getSubjectInfo} =this.props
    getSubjectInfo(id,sid)
    window.scrollTo(0, 0)
  }
  render(){
    // let subject = JSON.parse(localStorage.getItem("courseSubject")||"[]");
    let subject = this.props.courseinfo.toJS().subject||[];
    let courseid = JSON.parse(localStorage.getItem("courseid")||"{}");
    const { finishedList, finishedListLock } = this.props
    return (
      <div className="info-tab">
      <StickyContainer>
          <Tabs tabs={tabs}
            animated={false}
            initalPage={'t2'}
            swipeable={false}
             renderTabBar={renderTabBar}>
            <div className="tab-main">
              <WingBlank>
                <TabCatalog subject={subject} courseid={this.props.courseid} sid={this.props.sid} finish={finishedList} finishedListLock={finishedListLock} id={courseid} videoClick={(id,sid)=>{this.videoClick(id,sid)}}/>
              </WingBlank>
            </div>
            <div className="tab-main">
              <TabInterlocution/>
            </div>
          </Tabs>
        </StickyContainer>
      </div>
      )
  }
}

const mapState = (state) => ({
  finishedListLock: state.getIn(['labroomvideo', 'finishedListLock'])
})

const mapDispatch = (dispatch) => ({
  getSubjectInfo(course_id,sub_id){
      dispatch(actionCreators.getSubjectInfo(course_id,sub_id))
  }
})

export default connect(mapState, mapDispatch)(VideoTab);



